/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from 'react';
import config from '../../config';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchDemandePubs, deleteDemandePubs } from '../../services/actions/demandepubsActions';
import Spinner from '../../components/Spinner';
import Swal from 'sweetalert2';
import { showSuccessMessage, showErrorMessage } from '../../toastrActions';



function DemandePubsPage(props) {
    const { loading, demandepubs, fetchDemandePubs } = props;
    const dispatch = useDispatch();

    const showDeleteConfirmation = (id) => {
        Swal.fire({
            title: 'Etes vous sûr?',
            text: 'Cette action est irreversible',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Oui,Supprimer!',
            cancelButtonText: 'Annuler',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const success = await dispatch(deleteDemandePubs(id));
                if (success) {
                    dispatch(showSuccessMessage('Suppression avec succès!'));
                    // Swal.fire('Supprimé!', "Suppression avec Succès", 'success');
                } else {
                    dispatch(showErrorMessage("Une erreur s'est produite lors de la suppression de l'élément."));
                    //Swal.fire('Erreur', "Une erreur s'est produite lors de la suppression de l'élément.", 'error');
                }
            }
        });
    };

    useEffect(() => {
        fetchDemandePubs();
    }, [fetchDemandePubs]);

     return (
         <div id="content-page" className="content-page">
             <div className="container-fluid">
                 {loading ? (
                     <div className="card-body">
                         <Spinner />
                     </div>
                 ) : 
                     <div className="row">
                         <div className="col-lg-12">
                             <div className="iq-card-block iq-card-stretch iq-card-height overflow-hidden iq-card ">
                                 <div className="iq-card-header d-flex justify-content-between">
                                     <div className="iq-header-title">
                                         <h4 className="card-title text-primary">Demandes de Pub à partir du Bot</h4>
                                     </div>
                                     {/* <div className="iq-card-header-toolbar d-flex align-items-center">
                                         <button className="btn btn-info">
                                             <i className="ri-download-2-line" />
                                             Exporter
                                         </button>
                                     </div> */}
                                 </div>
                                 <div className="iq-card-body ">
                                     <div className="mb-0 table-responsive">
                                         <table
                                             role="table"
                                             aria-busy="false"
                                             aria-colcount={6}
                                             className="table b-table table-borderless"
                                             id="__BVID__485"
                                         >
                                             <thead role="rowgroup" className="">
                                                 <tr role="row" className="">
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={1}
                                                         className=""
                                                     >
                                                         <div>#</div>
                                                     </th>
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={2}
                                                         className=""
                                                     >
                                                         <div>Nom</div>
                                                     </th>
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={3}
                                                         className=""
                                                     >
                                                         <div>Email</div>
                                                     </th>
                                                     
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={5}
                                                         className=""
                                                     >
                                                         <div>Portable</div>
                                                     </th>
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={6}
                                                         className=""
                                                     >
                                                         <div>Section</div>
                                                     </th>
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={6}
                                                         className=""
                                                     >
                                                         <div>Date</div>
                                                     </th>
                                                     <th
                                                         role="columnheader"
                                                         scope="col"
                                                         aria-colindex={6}
                                                         className="text-center"
                                                     >
                                                         <div>Actions</div>
                                                     </th>
                                                 </tr>
                                             </thead>
                                             <tbody role="rowgroup">
                                                 {!loading && demandepubs.length === 0 ?
                                                     (
                                                         <tr className="text-center my-3">
                                                             <td colSpan="8">
                                                                 Aucune demande n'a été trouvée.
                                                             </td>
                                                         </tr>
                                                     ) : (demandepubs.map((demande, index) => (
                                                         <tr role="row" className="">
                                                             <td aria-colindex={1} role="cell" className="">
                                                                 {++index}
                                                             </td>
                                                             <td aria-colindex={2} role="cell" className="">
                                                                 {demande.nom}
                                                             </td>
                                                             <td aria-colindex={3} role="cell" className="">
                                                                 {demande.email}
                                                             </td>
                                                             <td aria-colindex={5} role="cell" className="">
                                                                 {demande.phone}
                                                             </td>
                                                             <td aria-colindex={5} role="cell" className="">
                                                                 
                                                                 <span className={`badge badge-info badge-pill`}>
                                                                     {demande.section}
                                                                 </span>
                                                             </td>
                                                             <td aria-colindex={6} role="cell" className="">
                                                                 {demande.created_at.slice(0, 10)}
                                                             </td>
                                                             <td aria-colindex={7} role="cell" className="">
                                                                 <div class="d-flex align-items-center justify-content-center">
                                                                     {/* <a class="avatar-45 text-center ml-3 rounded-circle iq-bg-success font-size-18"><i class="ri-pencil-fill font-size-16"></i></a> */}
                                                                     <a onClick={() => showDeleteConfirmation(demande.id)} class="avatar-45 rounded-circle text-center ml-3 iq-bg-danger font-size-18"><i class="ri-delete-bin-line font-size-16"></i></a>
                                                                 </div>
                                                             </td>
                                                         </tr>
                                                     )))
                                                     }
                                             </tbody>
                                         </table>
                                     </div>
                                 </div>
                                 {/**/}
                             </div>
                         </div>
                     </div>
                 }                
             </div>
         </div>
     );
}

const mapStateToProps = (state) => {
    return {
        demandepubs: state.demandepubs.demandepubs,
        loading: state.demandepubs.loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchDemandePubs: () => dispatch(fetchDemandePubs())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DemandePubsPage);